import { Controller } from 'stimulus'
import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

export default class extends Controller {
  connect() {
    new Splide(this.element.querySelector('.splide'), {
      type: 'loop',
      perPage: 6,
      gap: '20px',
      pagination: false,
      arrows: false,
      drag: 'free',
      autoScroll: {
        speed: 0.25,
        pauseOnHover: true,
        pauseOnFocus: false,
      },
      breakpoints: {
        1200: {
          perPage: 5,
        },
        1024: {
          perPage: 4,
        },
        767: {
          perPage: 3,
        },
        480: {
          perPage: 2,
        },
      },
    }).mount({ AutoScroll })
  }
}
